var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2220_2878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 18C4.03594 18 0 13.9641 0 9C0 4.03875 4.03594 0 9 0C13.9641 0 18 4.03875 18 9C18 13.9641 13.9613 18 9 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 18C4.03594 18 0 13.9641 0 9C0 4.03875 4.03594 0 9 0C13.9641 0 18 4.03875 18 9C18 13.9641 13.9613 18 9 18Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.01086 11.6157C9.50023 11.6157 9.7843 11.9307 9.7843 12.5832C9.7843 13.1795 9.49461 13.5254 9.00523 13.5254C8.54117 13.5254 8.24023 13.1992 8.24023 12.5832C8.24023 11.8913 8.53555 11.6157 9.01086 11.6157ZM8.32461 4.51416H9.6718L9.51992 10.7185H8.49898L8.32461 4.51416Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_2878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.3b9e866cc5939a8bbd800c7fd98982d3.svg";
export { ForwardRef as ReactComponent };